import { NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-input-field',
  standalone: true,
  imports: [FormsModule, NgIf],
  templateUrl: './input-field.component.html',
})
export class InputFieldComponent {
  @Input() label: string = ''; // Label for the input
  @Input() placeholder: string = ''; // Placeholder for the input
  @Input() value: string = ''; // Value for the input field
  @Input() errorMessage: string = 'Invalid input'; // Error message
  @Input() pattern: string = '.*'; // Default pattern to match any string
  @Input() maxLength: number | null = null;
  @Input() startValidate: boolean = false;
  @Output() valueChange = new EventEmitter<string>();

  isFocused: boolean = false; // Focus tracking

  onInputChange(newValue: string): void {
    this.value = newValue;
    this.valueChange.emit(newValue); // Emit the new value to the parent
  }

  // Validates the input value
  isValid(): boolean {
    const regex = new RegExp(this.pattern);
    return regex.test(this.value);
  }
}
